export default __webpack_public_path__ + "static/media/image1.0ec4131a.jpg";